import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { resetPasswordSchema } from "@/features/auth/schema/resetPasswordSchema";
import { resetPasswordApi } from "@/features/auth/services/resetPassword";
import { TResetPasswordForm } from "@/features/auth/types/resetPasswordForm";
import { TResetPasswordQuery } from "@/features/auth/types/resetPasswordQuery";
import { AppRoutes } from "@/routes/config";
import { setErrorForm, showError } from "@/utils/error";
import { getQueryFromURL } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const initForm: TResetPasswordForm = { email: "", newPassword: "", confirmNewPassword: "" };

export const ResetPasswordForm = () => {
  const query = getQueryFromURL<TResetPasswordQuery>();
  const methods = useForm<TResetPasswordForm>({
    mode: "onChange",
    defaultValues: { ...initForm, email: query?.email ?? "" },
    resolver: yupResolver(resetPasswordSchema),
  });
  const { control } = methods;
  const navigate = useNavigate();

  const onSubmit = async (data: TResetPasswordForm) => {
    const { newPassword } = data;
    if (!query) return;
    const { email, resetToken } = query;
    try {
      if (email && resetToken) {
        await resetPasswordApi({ email, newPassword, resetToken });
        navigate(AppRoutes.resetPasswordComplete);
      }
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  return (
    <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={resetPasswordSchema}>
      <Stack gap={3} width={400}>
        <FormField control={control} name="newPassword">
          <Input type="password" size="lg" />
        </FormField>
        <FormField control={control} name="confirmNewPassword">
          <Input type="password" size="lg" />
        </FormField>
        <Typography variant="body14">※パスワードはアルファベット大文字・小文字・数字・記号を含む12文字以上で入力してください。</Typography>
        <Button type="submit" size="sm" fullWidth>
          パスワードを再発行
        </Button>
      </Stack>
    </Form>
  );
};
